import {
  action_escalation_options,
  action_priority_options,
  action_source_options,
  action_status_options,
  all_action_cards,
  all_action_filters,
  all_action_rows,
  awaiting_approval_rows,
  by_source_cards,
  closure_cards,
  create_empty_action_form,
  recently_closed_rows,
  repeat_cards,
  repeat_groups,
  tabs
} from './corrective_actions_data';
import { corrective_drawer_computed } from './corrective_actions_drawer';
import { corrective_actions_computed, corrective_actions_methods } from './corrective_actions_helper';

export default {
  name: 'ComplyonFindingsCorrectiveActions',
  data: () => ({
    tabs,
    active_tab: 'all-actions',
    active_action_filter: 'all',
    active_action_drawer_ref: null,
    show_new_action_modal: false,
    new_action_error: '',
    new_action_form: create_empty_action_form(),
    action_source_options,
    action_priority_options,
    action_status_options,
    action_escalation_options,
    all_action_cards,
    all_action_filters,
    all_action_rows,
    by_source_cards,
    closure_cards,
    awaiting_approval_rows,
    recently_closed_rows,
    repeat_cards,
    repeat_groups
  }),
  computed: {
    ...corrective_actions_computed,
    ...corrective_drawer_computed
  },
  methods: {
    ...corrective_actions_methods
  }
};
